import type { Transaction } from '@src/domains/transactions/types/transaction';

/** A transaction the gateway already answered without approving it; a pending one has no answer yet. */
export const isFailedTransaction = (transaction?: Transaction | null): boolean =>
  Boolean(transaction && !transaction.pending && !transaction.succeeded);
